import { Component, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AuthService } from '../../../core/auth/auth.service';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatFormFieldModule, MatSelectModule]
})
export class NavbarComponent {
  isMobileMenuOpen = false;
  isExtraMenuOpen = false;
  activeSubmenu: string | null = null;
  selectedLanguage = 'AZ';
  openSubmenus = new Set<string>();

  constructor(public auth: AuthService, private router: Router, private el: ElementRef) {}

  onNewAnnouncementClick() {
    this.router.navigate(['/announcements/new']);
    this.isMobileMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isExtraMenuOpen = false;
      this.activeSubmenu = null;
      this.isMobileMenuOpen = false;
    }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    if (!this.isMobileMenuOpen) {
      this.openSubmenus.clear();
    }
  }

  toggleExtraMenu() {
    this.isExtraMenuOpen = !this.isExtraMenuOpen;
    if (this.isExtraMenuOpen) {
      this.activeSubmenu = null;
    }
  }

  toggleMainSubmenu(menu: string, event: Event) {
    event.preventDefault();
    if (this.activeSubmenu === menu) {
      this.activeSubmenu = null;
    } else {
      this.activeSubmenu = menu;
      this.isExtraMenuOpen = false;
    }
  }

  toggleSubmenu(menu: string) {
    if (this.openSubmenus.has(menu)) {
      this.openSubmenus.delete(menu);
    } else {
      this.openSubmenus.add(menu);
    }
  }

  logout(): void {
    this.auth.logout();
    this.router.navigate(['/']);
  }

  getLangFlag(lang: string): string {
    return lang === 'AZ' ? 'https://flagcdn.com/w40/az.png' : 'https://flagcdn.com/w40/gb.png';
  }
}
